<template>
    
    <v-container class="grey lighten-5" >
 <v-row justify="center" >
    <v-col class="mb-6">

  <div class="text-center">
        <h2>CAMBIO DE CLAVE</h2> <br>
        </div>

<v-card  :elevation="4"
          class="pa-2"
        
        >
<div class="text-center">
       <form>

   
    <v-text-field
            :type="'password'"
            v-model="oldpassword"
            :counter="20"
            label="Clave Anterior"
            required
            v-on:keyup="hideMessage"
          ></v-text-field>

          <v-text-field
            :type="'password'"
            v-model="newpassword"
            :counter="20"
            label="Nueva Clave"
            required
            v-on:keyup="hideMessage"
          ></v-text-field>

<!--<v-btn @click="actualizarPerfil" block color="primary">Actualizar Sede</v-btn><br>-->
    <v-btn @click="cmabioClave" block color="primary">CAMBIAR CLAVE</v-btn><br>
     
    
  </form>


  </div>

 

</v-card>
<br>
    
    </v-col>

  </v-row>


  <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Reactivacion de usuarios</v-card-title>

        <v-card-text>
          Desea reactivar el usuario {{nombre}} de nuevo ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="activateUserAgain"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


</v-container>

</template>


<script>

import axios from "axios";
import { actionStore } from "./CheckerLocalStorage";
import Tabla from "./Tabla";


 export default {

   components:{

     Tabla

   },

    data: vm => ({
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      e4: null,
      dropdown_font: ['Arial', 'Calibri', 'Courier', 'Verdana'],
      perfiles: [{ id: 1,nombrePerfilCargo: 'one'}],
      cargoNombre:[{ id: 1,nombrePerfilCargo: 'one'}],
      fecha:'',
      empresas: [{ id: 1,nombrePerfilCargo: 'one'}],
      select0:null,
      select1:null,
      select2:null,
      cedula:'',
      nombre:'',
      pagination:'',
      statusFailure:false,
      statusEmpty:false,
      statusCreated:false,
      search: '',
      selected: [],
      singleSelect: true,
      empresaSelected:{},
      statusLoader:false,
      oldpassword:'',
      newpassword:'',

      hora:'',
      url1:'',

      //*******TABLE PAGINATION */
        page: 0,
        pageCount: 0,
        itemsPerPage: 10,
        headers: [
          {
            text: 'ID',
            align: 'left',
            sortable: false,
            value: 'id',
          },
          { text: 'SEDE', value: 'nombre' },
       
         
        ],
        tabla:[],
             
        //*******TABLE PAGINATION */



    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      msg() {
      const selectedRow = this.selected[0];
        console.log(selectedRow);
      }
    },

    watch: {
      date () {
        this.dateFormatted = this.formatDate(this.date)
        this.fecha = "Fecha seleccionada: "+this.dateFormatted
      },
      e4 (){

        this.hora = "Hora seleccionada: "+this.e4
        console.log('it has cahnged..'+this.e4);

      },
     
      
    },

    beforeMount(){

     

    console.log('URL ..'+this.url1);
    },

     mounted () {

       this.getPerfiles();

     

    },

    methods: {


      cmabioClave: function(){

         if(this.oldpassword!="" && this.newpassword!=""){

           console.log(actionStore.methods.getInfoEmpresa());
           console.log(actionStore.methods.getEndpoints().URL_BACKEND+"/info/changepassword/"+actionStore.methods.getInfoEmpresa().idUsuario+"/"+this.oldpassword+"/"+this.newpassword);

           axios
            .post(actionStore.methods.getEndpoints().URL_BACKEND+"/info/changepassword/"+actionStore.methods.getInfoEmpresa().idUsuario+"/"+this.oldpassword+"/"+this.newpassword)
            .then(response => {
             
              if (response.status == 201 ) {
                
                alert('clave cambiada');

              }
             
             
            })
             .catch(error => {

          

              if (error.response.status == 400 ) {
               
                alert('clave invalida');
              }
            });

           
            


         }else{

           alert('campos vacios');

         }

      },


      actualizarPerfil:function(){

        if(this.selected.length>0){

          if(this.cedula!=""){

            let that = this;
            let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/updateperfil/'+this.cedula+'/'+this.selected[0].id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {

                          
                          that.getPerfiles();
                          that.cedula = "";
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        });


          }
        }else{

          
          alert('seleccione un perfil primero');

           
        }
       

      },

      eliminarPerfil:function(){

         
        if(this.selected.length>0){
           console.log("deleting "+this.selected[0].id);
              
             let that = this;
             let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/deletesede/'+this.selected[0].id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {

                          
                          that.getPerfiles();
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        }); 
                

          }


      },

      createPerfil:function(){


        if(this.cedula!=""){

          let that = this;
          let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/createsede/'+this.cedula+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {

                          that.cedula="";
                          
                          that.getPerfiles();
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        }); 



        }
        

      },

      getEmpresadetails:function(){

        this.empresas.map(item=>{

          if(item.id==this.select0){

            console.log(item);
            this.empresaSelected = item;

            this.getPerfiles();

          }

        })

      },

      getPerfiles:function(){
          let that = this;
          this.url1 = actionStore.methods.getInfoEmpresa().urlServer+'/register/getallsedes?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          console.log(this.url1);
          axios.get(this.url1)
            .then(function (response) {
                
                that.tabla = response.data;
          }).then();

      },

      activateUserAgain(){

        this.dialog=false;
        console.log("the ID  is "+ this.cedula);
        let that = this;
     
        let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/disableuser/'+this.cedula+'/1/'+this.select1+'/'+this.select2+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          that.enablingUser();
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        }); 

      },

      enablingUser: function(){

      let url = actionStore.methods.getEndpoints().URL_BACKEND+'/info/updateuser/'+this.cedula+'/1';

      let that = this;
      console.log(url);
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          //console.log("updated user..");
                          that.fillTable();
                          that.statusLoader=false;
                         
                        })
                        .catch(function (error) {
                          

                            console.log("the error is ");
                            console.log(error);
                      
                          
                        }); 

      },

      selectedItems:function(){
 
               console.log(this.selected);


               let that = this;
               this.selected.map(item=>{

               let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/disableuser/'+item.cedula+'/0/0/0?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
               console.log(url);
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          that.disablingUser(item.cedula,that);
                         
                        })
                        .catch(function (error) {
                          console.log('from error...');
                      
                          
                        }); 


            })

            

        },

        disablingUser:function(idSelectedUser,that){


          let url = actionStore.methods.getEndpoints().URL_BACKEND+'/info/updateuser/'+idSelectedUser+'/0';
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          //console.log("updated user..");
                          that.fillTable();
                         
                        })
                        .catch(function (error) {
                          console.log('from error...');
                      
                          
                        }); 


        },

       onPageChange: function () {
          //console.log('page '+this.page);
          this.fillTable();
       },


      fillTable:function(){


          let that = this;
          let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/usuariospaginados/'+this.page+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          axios.get(url)
              .then(function (response) {
                
                  that.pageCount = parseInt(response.data.totalPages);
                  that.tabla = response.data.infoUsuario;
                  
          }).then();

      },
      hideMessage:function(){

         this.statusEmpty = false;
         this.statusCreated = false;
         this.statusFailure = false;
      }, 

      getCargo:function(){

        this.hideMessage();
        //console.log('cargo selected..'+this.select2);

      },

      getPerfil: function(){

          this.hideMessage();
          console.log('perfil selected..'+this.select1);
          let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/cargos/'+this.select1+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          let that = this;
          axios.get(url)
            .then(function (response) {
                console.log(response);
                that.cargoNombre = response.data;
          }).then()

        
      },



      finish:function(){


       
        if(this.select1!='' && this.select2!='' && this.nombre!='' && this.cedula!=''){

             let that = this;
             let responsedata = '';
             let cedula1 = this.cedula;
             let nombre1 = this.nombre;
             
             this.statusLoader=true;
             let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/checkuser/'+cedula1+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
             //console.log("URL 1 "+url);
             axios.get(url)
                .then(function (response) {
                  
                    //console.log(response);
                    if(response.data=='EXISTS'){


                      console.log("from exists..");
                      let url2 = actionStore.methods.getInfoEmpresa().urlServer+'/register/checkuserstatus/'+cedula1+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;

                      axios.post(url2, {
                        })
                        .then(function (response2) {
                        
                          if(response2.data=='EXISTS'){

                              console.log("do you want to reactivate the USER again ?");
                              //that.activateUserAgain(cedula1);
                              that.dialog=true;

                          }else{

                             that.statusFailure=true;
                             that.statusLoader=false;

                          }

                        
                        })
                        .catch(function (error) {
                          //console.log('from error.*..');
                       
                        }); 




                     

                    }else{


                      let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/createuser?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                          fkIdPerfil:that.select1,
                          fkIdCargo:that.select2,
                          cedula:that.cedula,
                          nombre:that.nombre.toUpperCase(),
                          huella:""
                        })
                        .then(function (response) {
                         
                          //console.log('from success...');
                          //console.log(response);
                          //console.log(response.data);
                          responsedata = response.data;

                          that.creatingUser(responsedata,cedula1, nombre1, actionStore.methods.getInfoEmpresa().urlServer,that );
                          
                          that.cedula='';
                          that.nombre = '';
                        })
                        .catch(function (error) {
                          console.log('from error...');
                        
                          if(error.response.status==302){

                              that.statusFailure = true;
                              that.statusLoader=false;
                          }
                          
                        }); 


                    }
                    
             })
          
              

            
        }else{

            //console.log('campos vacios');
            this.statusEmpty = true;
        }


      },


      creatingUser:function(idUser, cedula, nombre, urlServer, that ){

          console.log('calling from second method');


            let url = actionStore.methods.getEndpoints().URL_BACKEND+"/api/auth/signup/user";
             axios.post(url, {
                    name:nombre,
                    username:cedula,
                    email:cedula+"@none.com",
                    password:cedula,
                    
                    fkIdTenantDetails:actionStore.methods.getInfoEmpresa().tenantId,
                    usuarioTenantId:idUser,
                    activo:"si"
                    


                              })
              .then(function (response) {
                
                 that.statusCreated = true;
                 that.statusLoader=false;

                 that.fillTable();
                //console.log('from success...');
                //console.log(response);
                
              })
              .catch(function (error) {

                console.log(error.message);
                //console.log('from error...2');
                if(error.response.status==400){

                              that.statusFailure = true;
                              that.statusLoader=false;
                          }
                
              });   



      },


      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${year}-${month}-${day}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
  }


</script>

